// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__O4BGA","blog":"styles_blog__PJRIA","h3":"styles_h3__Ppv9t","page":"styles_page__vmg7L","card":"styles_card__bImLT"};